// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
let __webpack_exports__ = __webpack_require__("webpack/container/entry/CSP");
